export const DeleteCardOnFileConfirmationMessages = {
    SUCCESS_ALERT_MESSAGE: 'Credit card has been successfully deleted.',
} as const;
